import React from "react";
import logoHeader from "./logo_header.png";

function LogoHeader(props) {
  return <img src={logoHeader} alt="Rivile-mscan" {...props} />;
}

export default LogoHeader;
